import formatPropertySelectorCreator from './formatPropertySelectorCreator';
const formatContentPath = formatPropertySelectorCreator('contentPath');
export default formatContentPath;